import './Projects.css';

import React from 'react';
import { Route } from 'react-router-dom';
import classnames from 'classnames';

import Project from '../Project/Project';

function Projects(props) {
  const data = [
    {
      slug: 'self-calibrating-launcher',
      name: 'Self-calibrating Launcher',
      description:
        'The self-calibrating launcher consists of a catapult powered by a DC motor, nine target pads that can detect when something lands on them, and an Arduino handling the system’s logic and controls. The goal of the system is to be able to launch a metal ball at a specified target pad without knowing the proper input value to do so ahead of time. The launcher has to calibrate itself to use the proper input value to launch the ball the appropriate distance. In order to do this, the system uses the target pads to figure out how far off the ball was from the desired target pad and makes adjustments.',
      media: [
        // {
        //   type: 'youtube',
        //   id: 'qDyitkzuwlg'
        // },
        // {
        //   type: 'video',
        //   src: 'test'
        // },
        {
          type: 'image',
          alt: 'DC motor launcher',
          src: 'launcher',
          caption:
            'The DC motor launcher mounted on a wood block. The rotational speed of the motor was kept constant for all launches. To change the launch distance, the time that the motor was allowed to move forward before reversing back to its starting position was adjusted.',
        },
        {
          type: 'image',
          alt: 'DC motor launcher (loaded)',
          src: 'launcher-loaded',
          caption:
            'Another view of the DC motor launcher, with a metal ball loaded this time.',
        },
        {
          type: 'image',
          alt: 'Bottom of target pad',
          src: 'pad-bottom',
          caption:
            'The target pads work based on capacitive sensing. Each target pad is hooked up to a separate capacitive touch sensor. This is the same technology that powers smartphone touch screens. Each sensor is connected to the aluminum foil on the bottom of each pad. When the ball lands on a pad, it pushes the pad down into the long strip of aluminum foil. When the aluminum foil on the bottom of the pad comes in contact with the long strip of aluminum foil, their combined capacitance is enough to cause a large reading on the capacitive sensor that the pad is connected to.',
        },
        {
          type: 'image',
          alt: 'Strip of target pads',
          src: 'pads',
          caption: 'A view of all nine target pads lined up.',
        },
        {
          type: 'image',
          alt: 'Electronics',
          src: 'electronics',
          caption: '',
        },
        {
          type: 'image',
          alt: 'Full system',
          src: 'full-system',
          caption: '',
        },
      ],
    },
  ];

  const projects = data.map(project =>
    <Route
      key={project.slug}
      path={'/' + project.slug}
      children={({ match }) =>
        <Project
          {...project}
          match={match}
          changeSection={props.changeSection}
        />}
    />,
  );

  return (
    <div className={classnames('Projects', props.className)}>
      {projects}
    </div>
  );
}

export default Projects;



// WEBPACK FOOTER //
// ./src/components/Projects/Projects.js